<template>
  <md-card>
    <md-card-content>
      <md-button v-if="queriedData.length>0"
                 class="md-primary md-raised"
                 @click="addActivities">
        Attach Activity
      </md-button>
      <md-table
          :value="queriedData"
          :md-sort.sync="currentSort"
          :md-sort-order.sync="currentSortOrder"
          :md-sort-fn="customSort"
          class="paginated-table table-striped table-hover">
        <md-table-toolbar>
          <md-field>
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages">
              <md-option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
              >
                {{ item }}
              </md-option>
            </md-select>
          </md-field>

          <md-field>
            <md-input
                type="search"
                class="mb-3"
                clearable
                style="width: 200px"
                placeholder="Search records"
                v-model="searchQuery"
                @input="searchOnTables">
            </md-input>
          </md-field>
        </md-table-toolbar>

        <md-table-empty-state
            md-label="No activity found"
            :md-description="`No Activity found for this '${search?search:''}' query. Try a different search term or attach Activity.`">
          <md-button class="md-primary md-raised"
                     @click="addActivities">
            Attach Activity
          </md-button>
        </md-table-empty-state>

        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Names" md-sort-by="name">{{ item.name }}
          </md-table-cell>
          <md-table-cell md-label="Status" md-sort-by="name">{{ item.status }}</md-table-cell>
          <md-table-cell md-label="Created At" md-sort-by="created_at">{{ toLocal(item.created_at) }}</md-table-cell>
          <md-table-cell md-label="Actions">
            <md-button
                class="md-just-icon md-info md-simple"
                @click.native="handleActivation(item)">
              <md-icon>lock</md-icon>
              -
              <md-icon>unlock</md-icon>
            </md-button>
            <md-button
                class="md-just-icon md-danger md-simple"
                @click="handleDelete(item)">
              <md-icon>delete</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>
    <md-card-actions md-alignment="space-between">
      <div class="">
        <p class="card-category">
          Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        </p>
      </div>
      <pagination
          class="pagination-no-border pagination-success"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
      >
      </pagination>
    </md-card-actions>
  </md-card>
</template>

<script>
import DateFormatMixin from '@/mixins/date-format-mixin';
import { Pagination } from '@/components';
import Swal from 'sweetalert2';
import Fuse from 'fuse.js';

const toLower = text => {
    return text.toString().toLowerCase();
};
const searchByName = (items, term) => {
    if (term) {
        return items.filter(item => toLower(item.name).includes(toLower(term)));
    }
    return items;
};
export default {
    name: 'WorkplaceActivityTable',
    components: {
        Pagination
    },
    computed: {
        queriedData () {
            let result = this.searchedActivitys;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to () {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total () {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.searchedActivitys.length;
        }
    },
    mixins:[DateFormatMixin],
    props: {
        workplace: {
            type: Object,
            default: () => {
            }
        },
        tableData: {
            type: Array,
            default: ()=>[]
        },
        type: {
            type: String,
            default: 'Workplace'
        }
    },
    data () {
        return {
            currentSort: 'name',
            currentSortOrder: 'asc',
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            footerTable: ['Name', 'Email'],
            searchQuery: '',
            search: null,
            propsToSearch: ['name', 'email'],
            searchedData: [],
            searchedActivitys: [],
            fuseSearch: null,
        };
    },
    created () {
        this.searchedActivitys = this.tableData;
    // this.getTableData()
    },
    methods: {
        async getTableData () {
            const params = {
                include: 'activity',
                filter: {
                    ...(this.workplace ? { workplace: this.workplace.id } : {}),
                },
            };
            await this.$store.dispatch('activityWorkplaces/list', { params: params });
            this.searchedActivitys = this.$store.getters['activityWorkplaces/list'];
        },
        searchOnTables (searchKey) {
            this.searchedActivitys = searchByName(this.tableData, searchKey);
        },
        customSort (value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort;
                if (this.currentSortOrder === 'desc') {
                    return a[sortBy].localeCompare(b[sortBy]);
                }
                return b[sortBy].localeCompare(a[sortBy]);
            });
        },
        handleActivation (item) {
            console.log(item);
        },
        handleDelete (item) {
            console.table(item);
            const activityName = item.name;
            Swal.fire({
                title: 'Are you sure?',
                text: `Remove Activity '${activityName}' from ${this.type} ${this.workplace.name}`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'md-button md-success btn-fill',
                cancelButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false
            }).then(async result => {
                if (result.value) {
                    this.$emit('removeActivity',item);
                    // await this.$store.dispatch("activityWorkplaces/destroy", item.id);
                    // this.deleteRow(item);
                }
            });
        },
        deleteRow (item) {
            let indexToDelete = this.tableData.findIndex(
                tableRow => tableRow.id === item.id
            );
            if (indexToDelete >= 0) {
                console.log('call in main');
                // this.tableData.splice(indexToDelete, 1);
            }
        },
        addActivities () {
            this.$emit('add:activity:workplace', this.workplace.id);
        }
    },
    mounted () {
    // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: ['name'],
            threshold: 0.3
        });
    },
    watch: {
        searchQuery (value) {
            let result = this.tableData;
            if (value !== '') {
                result = this.fuseSearch.search(this.searchQuery);
            }
            this.searchedData = result;
        },
        tableData () {
            // this.getTableData();
            this.searchedActivitys =  this.tableData;
        }
    }
};
</script>

<style scoped>

</style>
